/**
 * Image lightbox behaviour.
 * Relies on the dialog markup rendered once by snippets/image-lightbox.liquid
 * (included globally at the end of <body> in layout/theme.liquid).
 *
 * Triggers: any clickable element carrying
 *   data-lightbox="<full-size-url>"
 *   data-lightbox-alt="<alt text>"            (optional)
 *   data-lightbox-gallery="<gallery name>"    (optional; enables prev/next)
 */

const dialog = document.querySelector('[data-image-lightbox]');

if (dialog) {
  const dialogImg = dialog.querySelector('[data-image-lightbox-img]');
  const closeBtn = dialog.querySelector('[data-image-lightbox-close]');
  const prevBtn = dialog.querySelector('[data-image-lightbox-prev]');
  const nextBtn = dialog.querySelector('[data-image-lightbox-next]');

  let galleryItems = [];
  let currentIndex = 0;

  function show(index) {
    const item = galleryItems[index];
    dialogImg.src = item.src;
    dialogImg.alt = item.alt;
    currentIndex = index;
  }

  function navigate(direction) {
    if (galleryItems.length < 2) return;
    const next = (currentIndex + direction + galleryItems.length) % galleryItems.length;
    show(next);
  }

  function openLightbox(trigger) {
    const src = trigger.dataset.lightbox;
    const alt = trigger.dataset.lightboxAlt || '';
    const gallery = trigger.dataset.lightboxGallery;

    if (gallery) {
      galleryItems = Array.from(
        document.querySelectorAll(`[data-lightbox-gallery="${gallery}"]`)
      ).map((el) => ({
        src: el.dataset.lightbox,
        alt: el.dataset.lightboxAlt || '',
      }));
      const found = galleryItems.findIndex((item) => item.src === src);
      currentIndex = found === -1 ? 0 : found;
    } else {
      galleryItems = [{ src, alt }];
      currentIndex = 0;
    }

    const hasMultiple = galleryItems.length > 1;
    prevBtn.hidden = !hasMultiple;
    nextBtn.hidden = !hasMultiple;

    show(currentIndex);
    dialog.showModal();
  }

  closeBtn.addEventListener('click', () => dialog.close());
  prevBtn.addEventListener('click', () => navigate(-1));
  nextBtn.addEventListener('click', () => navigate(1));

  dialog.addEventListener('click', (event) => {
    if (event.target === dialog) dialog.close();
  });

  dialog.addEventListener('keydown', (event) => {
    if (event.key === 'ArrowLeft') navigate(-1);
    if (event.key === 'ArrowRight') navigate(1);
  });

  document.addEventListener('click', (event) => {
    const trigger = event.target.closest('[data-lightbox]');
    if (!trigger) return;
    event.preventDefault();
    openLightbox(trigger);
  });
}
